<template>
  <label class="w-full h-full only-image">
    <!-- 파일 입력 -->
    <input ref="fileInput" id="file-input" type="file" accept="image/*" @change="handleFileUpload" class="hidden-input" :disabled="readonly" />

    <!-- 이미지 미리보기 -->
    <div v-if="resizedImage" class="preview">
      <img :src="resizedImage" alt="Resized Image" class="preview-image" />

      <div class="absolute" style="bottom: 0; right: 4px">
        <!--        승인-->
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#CAF9DF" />
          <path
            d="M13.6436 5.95116C13.5413 5.85414 13.4039 5.7998 13.2607 5.7998C13.1175 5.7998 12.98 5.85414 12.8778 5.95116L7.95419 10.823L5.98471 8.81073C5.93769 8.75003 5.87776 8.69982 5.80895 8.66351C5.74013 8.62719 5.66408 8.6056 5.5859 8.60022C5.50772 8.59484 5.42921 8.60579 5.35578 8.63232C5.28235 8.65884 5.21567 8.70036 5.16024 8.754C5.10482 8.80765 5.06197 8.8722 5.03456 8.94328C5.00716 9.01435 4.99582 9.09029 5.00137 9.16597C5.00693 9.24164 5.02924 9.31529 5.06675 9.3819C5.10427 9.44852 5.15617 9.50655 5.21888 9.55207L7.6259 11.988C7.6259 12.0939 7.84478 12.1998 7.95419 12.1998C8.03912 12.1998 8.12285 12.1807 8.19881 12.1439C8.27477 12.1071 8.34085 12.0538 8.39181 11.988L13.6436 6.69254C13.7438 6.59355 13.8 6.46046 13.8 6.32185C13.8 6.18324 13.7438 6.05015 13.6436 5.95116Z"
            fill="#28C76F"
          />
        </svg>

        <!--        취소-->
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" @click.stop.prevent="clearImage">
          <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#DCDFE2" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9655 7.16549C12.2779 6.85307 12.2779 6.34654 11.9655 6.03412C11.6531 5.7217 11.1465 5.7217 10.8341 6.03412L8.9998 7.86843L7.16549 6.03412C6.85307 5.7217 6.34654 5.7217 6.03412 6.03412C5.7217 6.34654 5.7217 6.85307 6.03412 7.16549L7.86843 8.9998L6.03412 10.8341C5.7217 11.1465 5.7217 11.6531 6.03412 11.9655C6.34654 12.2779 6.85307 12.2779 7.16549 11.9655L8.9998 10.1312L10.8341 11.9655C11.1465 12.2779 11.6531 12.2779 11.9655 11.9655C12.2779 11.6531 12.2779 11.1465 11.9655 10.8341L10.1312 8.9998L11.9655 7.16549Z"
            fill="#3C3C3C"
          />
        </svg>
      </div>
    </div>
    <div v-else class="content-upload">
      <!-- 이미지 업로드 영역 -->
      <slot>
        <img class="img-icon" :src="require('@/assets/images/_bs/Union.png')" />
      </slot>
    </div>
  </label>
</template>

<script>
export default {
  name: "ImageToBase64Form",
  props: {
    readonly: Boolean,
    value: { type: [Object, String], default: "" },
    maxWidth: {
      type: Number,
      default: 800, // 최대 이미지 너비 (px)
    },
    maxHeight: {
      type: Number,
      default: 800, // 최대 이미지 높이 (px)
    },
    quality: {
      type: Number,
      default: 0.8, // 압축 품질 (0.1 ~ 1)
    },
  },
  data() {
    return {
      resizedImage: this.value, // 리사이즈된 이미지 Base64 데이터
    };
  },
  watch: {
    value: {
      handler(value) {
        this.resizedImage = value;
      },
    },
    resizedImage: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    triggerFileInput(event) {
      event.stopPropagation(); // 이벤트 버블링 방지
      if (!this.readonly) {
        this.$refs.fileInput.click();
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            const { width, height } = this.getScaledDimensions(img.width, img.height);

            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(img, 0, 0, width, height);

            const resizedData = canvas.toDataURL("image/jpeg", this.quality);

            this.resizedImage = resizedData; // 부모로 리사이즈된 Base64 전달

            // 파일 입력 값을 초기화하여 동일한 파일 선택 가능하도록 처리
            this.resetFileInput();
          };
        };

        reader.readAsDataURL(file);
      }
    },
    resetFileInput() {
      // 파일 입력 요소를 강제로 초기화하여 동일 파일 재선택 가능
      this.$refs.fileInput.value = null;
    },
    clearImage() {
      this.resizedImage = "";
    },
    getScaledDimensions(origWidth, origHeight) {
      let width = origWidth;
      let height = origHeight;

      if (origWidth > this.maxWidth || origHeight > this.maxHeight) {
        const aspectRatio = origWidth / origHeight;

        if (origWidth > origHeight) {
          width = this.maxWidth;
          height = Math.round(this.maxWidth / aspectRatio);
        } else {
          height = this.maxHeight;
          width = Math.round(this.maxHeight * aspectRatio);
        }
      }

      return { width, height };
    },
  },
};
</script>
<style lang="scss" scoped>
.hidden-input {
  display: none;
}

.preview {
  margin-top: 20px;
}

.preview-image {
  max-width: 100%;
  height: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.only-image {
  cursor: pointer;
  position: relative;

  border: 2px dashed #cdcdcd;
  border-radius: 6px;
  background-color: transparent;

  color: #3c3c3c;
  font-size: 12px;
  font-weight: bold;

  display: flex;
  align-items: center;
  justify-content: center;

  .img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
  .content-upload {
    display: grid;
    place-content: center;
    text-align: center;
    .img-icon {
      margin: 0 auto;
      //width: 30px;
      //height: 30px;
    }
  }
}
</style>
